import React from 'react';
interface CardProps {
  children: React.ReactNode;
  className?: string;
}
export function Card({
  children,
  className = ''
}: CardProps) {
  return <div className={`bg-white rounded-xl shadow-md border border-gray-100 overflow-hidden ${className}`} data-id="element-304">
      {children}
    </div>;
}